import { defineMessage, MessageDescriptor } from 'react-intl';
import { ScheduleStatusFilterValue, ScheduleStatusKind } from './get-schedule-status-kind';

export const scheduleStatusOverviewAllMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.overview.all',
  defaultMessage: 'Todos',
});

export const scheduleStatusHeaderMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.status',
  defaultMessage: 'Estado',
});

export const scheduleStatusHelpMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.status.help',
  defaultMessage:
    'Los números indican matches con schedule / schedules.\n\nCompleto: todos los schedules tienen un match.\nParcial: faltan matches para cubrir todos los schedules.\nSin emisión: hay schedules y ningún match.\nSin matches: no hay matches ni schedules.\n\nEl ícono de advertencia indica que algún match está fuera de tolerancia.',
});

const scheduleStatusOffToleranceMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.status.offTolerance',
  defaultMessage: 'Fuera de tolerancia',
});

export const scheduleStatusKindMessages: Record<ScheduleStatusKind, MessageDescriptor> = {
  complete: defineMessage({
    id: 'audit.scheduleStatusScreen.status.complete',
    defaultMessage: 'Completo',
  }),
  partial: defineMessage({
    id: 'audit.scheduleStatusScreen.status.partial',
    defaultMessage: 'Parcial',
  }),
  missingEmission: defineMessage({
    id: 'audit.scheduleStatusScreen.status.missingEmission',
    defaultMessage: 'Sin emisión',
  }),
  none: defineMessage({
    id: 'audit.scheduleStatusScreen.status.none',
    defaultMessage: 'Sin matches',
  }),
};

export const scheduleStatusFilterMessages: Record<ScheduleStatusFilterValue, MessageDescriptor> = {
  ...scheduleStatusKindMessages,
  offTolerance: scheduleStatusOffToleranceMessage,
};

export const scheduleStatusChipTooltipMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.status.chipTooltip',
  defaultMessage:
    '{matchesCount} matches / {matchesWithScheduleCount} con schedule / {schedulesCount} schedules',
});

export const scheduleStatusChipTooltipOffToleranceMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.status.chipTooltipOffTolerance',
  defaultMessage:
    '{matchesCount} matches / {matchesWithScheduleCount} con schedule / {schedulesCount} schedules ({offToleranceCount} fuera de tolerancia)',
});

export const scheduleStatusNoAudioMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.noAudio',
  defaultMessage: 'Sin material',
});

export const scheduleStatusDetailSchedulesMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.detailModal.schedules',
  defaultMessage: 'Schedules',
});

export const scheduleStatusDetailUnmatchedMatchesMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.detailModal.unmatchedMatches',
  defaultMessage: 'Matches sin schedule',
});

export const scheduleStatusDetailNoMatchedScheduleMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.detailModal.noMatchedSchedule',
  defaultMessage: 'Sin schedule',
});

export const scheduleStatusDetailScheduledAtMessage = defineMessage({
  id: 'audit.props.datetime',
  defaultMessage: 'Fecha y hora programada',
});

export const scheduleStatusDetailMatchDatetimeMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.detailModal.matchDatetime',
  defaultMessage: 'Fecha y hora emitida',
});

export const scheduleStatusDetailMatchedScheduleMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.detailModal.matchedSchedule',
  defaultMessage: 'Schedule c/match',
});

export const scheduleStatusDetailMatchesMessage = defineMessage({
  id: 'audit.scheduleStatusScreen.detailModal.matches',
  defaultMessage: 'Match confirmado',
});

export const scheduleStatusDetailActionsMessage = defineMessage({
  id: 'common.text.actions',
  defaultMessage: 'Acciones',
});

export const closeDialogMessage = defineMessage({
  id: 'common.close',
  defaultMessage: 'Cerrar',
});
